import { ASPECTS } from "../lib/constants";

const ASPECT_CLASS = {
  "1:1": "aspect-square",
  "9:16": "aspect-[9/16] max-h-96 mx-auto",
  "16:9": "aspect-video",
};

/**
 * Aspect-ratio switcher (1:1 / 9:16 / 16:9) + the active creative image.
 * Renders nothing when there are zero creatives.
 */
export default function CreativeSwitcher({
  creatives,
  aspect,
  onSelect,
  platform,
}) {
  if (!creatives?.length) return null;

  const activeCreative =
    creatives.find((c) => c.aspect === aspect) || creatives[0];

  return (
    <div className="mb-4">
      <div className="flex gap-1 mb-2">
        {ASPECTS.map((a) => {
          const hasAsset = creatives.some((c) => c.aspect === a);
          const isActive = aspect === a;
          return (
            <button
              key={a}
              disabled={!hasAsset}
              onClick={() => onSelect(a)}
              data-testid={`aspect-${platform}-${a.replace(":", "x")}`}
              className={`flex-1 px-2 py-1.5 border font-mono text-[10px] uppercase tracking-wider transition-colors ${
                isActive
                  ? "border-[#ccff00] bg-[#ccff00]/10 text-[#ccff00]"
                  : hasAsset
                    ? "border-white/10 text-zinc-400 hover:border-white/30"
                    : "border-white/5 text-zinc-700 cursor-not-allowed"
              }`}
            >
              {a}
            </button>
          );
        })}
      </div>
      {activeCreative?.data && (
        <div
          className={`relative border border-white/5 overflow-hidden ${ASPECT_CLASS[aspect]}`}
        >
          <img
            src={`data:${activeCreative.mime_type};base64,${activeCreative.data}`}
            alt={`${platform} ${aspect} creative`}
            className="w-full h-full object-cover"
          />
          <span
            className="absolute top-1.5 left-1.5 font-mono text-[9px] uppercase tracking-wider px-1.5 py-0.5 bg-black/70 text-white border border-white/20"
            data-testid={`creative-source-${platform}`}
          >
            {activeCreative.source === "scraped" ? "from site" : "AI"}
          </span>
        </div>
      )}
    </div>
  );
}
